<template>
  <div>
     <a-modal class="" title="添加污染物" :visible="addPollutanVisiblet"  @cancel="closeVisible"  width="70%" @ok="submit" >
            <a-input class="a_select_self margin_self" v-model="factorName" allowClear placeholder="污染物名称" />
            <a-button type="primary" @click="search" style="margin-right: 5px">查询</a-button>
     <div class="containerBottom" id="content_main_center_scroll">
                <a-table :data-source="addPollutantList" bordered :loading="loading" :pagination="false" :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }" 
                 :row-selection="{ selectedRowKeys: selectedRowKeys[pagination.current], onChange: onSelectChange }">
                <a-table-column key="index" title="序号" ellipsis="true" data-index="index"  width="100px">
                    <template scope="text, record, index">
                    {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
                    </template>
                </a-table-column>
                <a-table-column key="factorName" title="污染物名称" ellipsis="true" data-index="factorName" />
                <a-table-column key="standardInfo" title="检测标准" ellipsis="true" data-index="standardInfo" />
                <a-table-column key="limitRange" title="限制" ellipsis="true" data-index="limitRange" />
                </a-table>
            <div class="pageBottom">
                <a-pagination
                      v-model="pagination.current"
            show-size-changer
            :page-size.sync="pagination.pageSize"
            :total="pagination.totalCount"
			@showSizeChange="onShowSizeChange"
            :pageSizeOptions="['10', '20', '30','40', '50','100','200']"
            @change="onShowSizeChange"
                />
            </div> 

     </div>
     </a-modal>

  </div>
</template>

<script>
import { addReation,getQuoteBaseFactorFilterList } from '@/api/surrounding'
export default {
    props: [
        // 'addPollutanVisiblet',
        // 'addPollutantList',
        // 'factorName',
        // 'ids'
    ],
    data() {
        return {
            addPollutantList: [],
            addPollutanVisiblet: false,
            // selectedRowKeys: '',
            selectedRowKeys: {
                1: [],
            },
            selectedData: {},
            factorName: '',
            scroll_y: 150,
            // pollutantList: [],
            pagination:{ //分页数据
			     pageSizeOptions: ['10', '20', '30', '40', '50'],
                 current : 1,
                 pageSize: 10,
                 totalCount: 0
            },
            rowData: {}
            // addPollutant: false

        }
    },
    mounted(){
         this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() + 180
				}, 1000)
			})

    },
    methods: {
        init(data) {
        this.rowData = data
        this.pagination.current = 1
        this.pagination.pageSize = 10
        getQuoteBaseFactorFilterList({
            pageIndex: this.pagination.current,
            pageSize: this.pagination.pageSize,
            masterCategoryId: data.masterCategoryId,
            subCategoryId: data.subCategoryId,
            pollutantTypeId: data.pollutantTypeId,
            categoryId: 1001,
            // quoteCategoryPollutant: data,
        }).then((res) => {
          if (res.code == 200) {
            this.addPollutantList = res.data.list,
            this.pagination.totalCount = res.data.totalCount
             this.addPollutanVisiblet = true // this.$refs.addPollutant.init()
          } else {
            this.$message.error(res.msg)
          }
        })
            
            
        },
        //获取数据
        getData() {
            console.log(this.pagination.current, this.pagination.pageSize, '=======================');
        getQuoteBaseFactorFilterList({
            pageIndex: this.pagination.current,
            pageSize: this.pagination.pageSize,
            // quoteCategoryPollutant:  this.rowData,
            masterCategoryId:  this.rowData.masterCategoryId,
            subCategoryId:  this.rowData.subCategoryId,
            pollutantTypeId:  this.rowData.pollutantTypeId,
            categoryId: 1001,
             factorName: this.factorName
        }).then((res) => {
          if (res.code == 200) {
            this.addPollutantList = res.data.list
            console.log(this.addPollutantList, 'addPollutantList============')
            this.pagination.totalCount = res.data.totalCount
          } else {
            this.$message.error(res.msg)
          }
        })

        },
         onShowSizeChange(current, pageSize) {
        console.log(current, pageSize);
        this.pagination.current = current
        this.pagination.pageSize = pageSize;
        //改变完 重新渲染数据
         this.getData()
      },
    //     onShowSizeChange(current, pageSize) {
    //     this.$nextTick(()=> {
    //     console.log(current, pageSize, '=======================');
    //     this.pagination.current = current
    //     this.pagination.pageSize = pageSize;
        
    //         //改变完 重新渲染数据
    //      this.getData()
    //     })
    //   },
        search() {
            this.pagination.current = 1
        // this.pagination.pageSize = pageSize
        //改变完 重新渲染数据
         this.getData()
            // this.$emit('getList', this.factorName)
        },
        //  onSelectChange(selectedRowKeys, val) {
        //     console.log(selectedRowKeys, val, 'valvalvalvalvalvalvalvalval')
        //     this.selectedRowKeys = selectedRowKeys
        //     this.pollutantList = val
        // },
          onSelectChange(selectedRowKeys, val) {
            console.log(selectedRowKeys, val, 'valvalvalvalvalvalvalvalval')
            this.selectedRowKeys[this.pagination.current] = selectedRowKeys
            this.selectedData[this.pagination.current] = val
            this.getData()
            console.log(this.selectedRowKeys[this.pagination.current], 'this.selectedRowKeys[this.pagination.current]')
            console.log(this.selectedRowKeys, 'this.selectedRowKeys[this.pagination.current]')

        },
        closeVisible() {
             this.selectedRowKeys = {}
             this.selectedData = {}
            this.addPollutanVisiblet = false
            // this.$emit('changeAddPollutanVisiblet',  this.addPollutanVisiblet )
        },
        //提交事件
        submit() {
            // if (this.selectedRowKeys != '') {
            var obj =this.selectedData
            var ids = []
             for (let i in obj) {
                obj[i].forEach(item => {
                    ids.push(item.id)
                })
          
            }
            // }
            // this.pollutantList.forEach(item => {
            //     rowId.push(item.id)

            // }
            console.log(this.selectedData, 'this.selectedData=========================')
            if(Object.keys(this.selectedData).length != 0) {
            addReation({
               quoteCategoryPollutant: this.rowData,
                ids: ids
            }).then(res => {
                if(res.code == 200) {
                    this.$message.success(res.msg)
                    //刷新数据列表
                    this.$emit('getData')
                    this.addPollutanVisiblet = false
                    // this.$emit('changeAddPollutanVisiblet',  this.addPollutanVisiblet )
                    this.selectedRowKeys = {}
                    this.selectedData = {}
                    // this.pollutantList = ''
                } else {
                    this.$message.error(res.msg)
                }

            })
            
            } else {
                this.$message.warning('请选择要添加的污染物')
            }
        }

    }

}
</script>

<style scoped>
.containerBottom {
    margin-top: 10px;
}
.pageBottom {
    margin: 10px;
    display: flex;
    flex-direction: row-reverse;
}

</style>